import { useEffect, useRef } from 'react';

export default function Gallery() {
     const galleryRef = useRef();
     useEffect(() => {
          const node = galleryRef.current;
        
          const observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                node.classList.add('visible');
              }
            },
            { threshold: 0.1 }
          );
        
          if (node) {
            observer.observe(node);
          }
        
          return () => {
            if (node) {
              observer.unobserve(node);
            }
          };
        }, []);
        
      
     return(
          <section className = "gallery-section" >
               <h2 className = "gallery-title">
                    Gallery
               </h2>
               <div className = "gallery-grid fade-in" ref={galleryRef}>
               <img src="/images/roof1.jpeg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':0}}/>
               <img src="/images/roof2.jpeg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':1}} />
               <img src="/images/roof3.jpeg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':2}}/>
               <img src="/images/roof4.jpeg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':3}}/>
               <img src="/images/roof5.jpeg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':4}}/>
               <img src="/images/contactFormBG.jpeg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':5}}/>
               <img src="/images/brooklyn.jpg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':6}}/>
               <img src="/images/brooklyn 2.jpg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':7}}/>
               <img src="/images/pic1.jpg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':8}}/>
               <img src="/images/pic2.jpg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':9}}/>
               <img src="/images/kent ave 2.jpg" alt="Rose bloom" className="gallery-item fade-item" style ={{'--i':10}}/>
               </div>
          </section>
     );
}